import React from 'react'

const UserPermissionsContentHeader = () => (
    <>
        <p>This page allows Super Users to add new users or edit existing users&apos; permissions.</p>
        <p>
            Click the <strong>three dots</strong> to the right of an existing user&apos;s name to re-send their invite
            or remove them. Click <strong>View </strong> to be taken to a page to update or edit their permission.
        </p>
        <p>
            Definitions for each user permission can be viewed&nbsp;
            <a href="https://help.themlc.com/en/support/what-are-the-different-types-of-permissions">here.</a>
        </p>
    </>
)

export default UserPermissionsContentHeader
